import React from 'react';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';
import TimecardIcon from '@material-ui/icons/Schedule';

import backgroundColor from '@material-ui/core/colors/indigo';

import ImportStepper from './ImportStepper';
import ImportTime from './ImportTime';
import ImportMaterials from './ImportMaterials';
import ImportLineItems from './ImportLineItems';

import { selectTimecardsList } from '../../../store/selectors';

const styles = theme => ({
  rootContent: {
  },
  title: {
    backgroundColor: backgroundColor[500],
  },
  titleTypography: {
    color: "#fff",
  },
});

const ImportDialog= (props) => {
  const {
    classes,
    open,
    onClose,
    invoice,
    workTypes,
    crew,
    timecards,
    receipts
  } = props;

  return(
    <Dialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={onClose}
    >
      <DialogTitle className={classes.title}>
        <div>
          <Typography variant="display1" className={classes.titleTypography}>
            Import Time & Materials
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent classes={{root: classes.rootContent}}>
        <ImportStepper
          steps = {[
            {
              label: "Import Time",
              isOptional: true,
              content: <ImportTime invoice={invoice} />,
            },
            {
              label: "Import Materials",
              isOptional: true,
              content: <ImportMaterials invoice={invoice} />,
            },
            {
              label: "Review",
              isOptional: false,
              content: <ImportLineItems invoice={invoice} />,
            }
          ]}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}

export default withStyles(styles)(ImportDialog);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/ImportDialog.jsx